import { useIntl } from 'react-intl';

export type UseTranslateType = (id: string, values?: Record<string, any>) => any;
export const useTranslate = () => {
  const { formatMessage } = useIntl();
  const t = (id: string, values?: Record<string, any>) => formatMessage({ id }, values);
  return { t };
};
